import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import type { PaymentAlertBody } from '../alertHover.types'
import { paymentStyles } from './Payment.styles'
import { useTranslation } from 'react-i18next'

const PaymentBody: React.FC<{ body: PaymentAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body) {
    return null
  }

  const rows = [
    { label: t('payment.failed'), value: body?.failed },
    { label: t('payment.outstanding'), value: body?.outstanding },
  ]

  const visibleRows = rows.filter((row) => row.value !== undefined && row.value !== null)

  if (visibleRows.length === 0) {
    return null
  }

  return (
    <Box sx={paymentStyles.root}>
      {visibleRows.map(({ label, value }) => (
        <Box key={label} sx={paymentStyles.row}>
          <Typography sx={paymentStyles.value}>{value}</Typography>
          <Typography sx={paymentStyles.label}>{label}</Typography>
        </Box>
      ))}
    </Box>
  )
}

export default PaymentBody
